module.exports = __webpack_public_path__ + "img/phobos.de4c6537.png";